/*
 * Copyright (c) 2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { defaultError, defaultErrorResponse } from "../RequestUtil";
import { parseClientInfo, parseGuestAccountList } from "./Util";

export const parseClientData = ({response}) => {
  const { guest, user_activity_logs } = response;
  if (guest == null) {
    return defaultErrorResponse;
  }

  const data = parseClientInfo(guest, user_activity_logs);
  return { data: data };
};

export const parseClientDataNewToken = ({response}) => {
  const { guest, user_activity_logs, token } = response;
  if (guest == null) {
    return defaultErrorResponse;
  }

  const data = parseClientInfo(guest, user_activity_logs);
  return {
    data: data,
    request: {
      token: token,
    },
  };
};

export const parseClientList = ({response}) => {
  const { guest_accounts } = response;
  if (guest_accounts == null) {
    return defaultErrorResponse;
  }

  return {
    account: {
      loggedIn: true,
      accountList: parseGuestAccountList(guest_accounts),
    },
  };
};

export const parseClientListNewToken = ({response}) => {
  const { guest_accounts, token } = response;
  if (guest_accounts == null || token == null) {
    return defaultErrorResponse;
  }

  return {
    account: {
      loggedIn: true,
      accountList: parseGuestAccountList(guest_accounts),
    },
    request: {
      token: token,
    },
  }
};

export const parseDataConfig = ({response}) => {
  const { branding } = response;
  if (branding == null) {
    return defaultErrorResponse;
  }

  const item = branding;
  return {
    login: {
      config: {
        id: item.id,
        title: item.title,
        dashboardDomain: item.dashboard_domain,
        dashboardDomainVerified: item.dashboard_domain_verified,
        hasSmsConfig: item.has_sms_config,
        hasEmailConfig: item.has_email_config,
        hasFacebookConfig: item.has_facebook_config,
        hasGoogleConfig: item.has_google_config,
        hasTwitterConfig: item.has_twitter_config,
        facebookConfig: item.facebook_config ? {
          clientId: item.facebook_config.client_id,
          clientSecret: item.facebook_config.client_secret,
          status: item.facebook_config.status,
          error: item.facebook_config.error,
          enabled: item.facebook_config.enabled,
        } : null,
        googleConfig: item.google_config ? {
          clientId: item.google_config.client_id,
          clientSecret: item.google_config.client_secret,
          status: item.google_config.status,
          error: item.google_config.error,
          enabled: item.google_config.enabled,
        } : null,
        twitterConfig: item.twitter_config ? {
          consumerKey: item.twitter_config.consumer_key,
          consumerSecret: item.twitter_config.consumer_secret,
          status: item.twitter_config.status,
          error: item.twitter_config.error,
          enabled: item.twitter_config.enabled,
        } : null,
      }
    }
  }
};
